import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Backstage hands out both relative portal routes and absolute URLs to GitHub,
 * Azure and the like. Only the latter should open in a new tab, and only they
 * need the `noopener` guard.
 */
export function isExternalLink(link: string): boolean {
  try {
    return (
      new URL(link, window.location.origin).origin !== window.location.origin
    );
  } catch {
    return false;
  }
}
